import { domainRegex } from './constants';

export default (domain) => domainRegex.exec(domain)[1];
